import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import { getThumbnails, getIndicators } from './thumbnailApi'

const thumbnailAdapter = createEntityAdapter({
    selectId: file => file.fileId,
})

export const thumbnailSelector = thumbnailAdapter.getSelectors(state => state.thumbnails)

export const getFileThumbnails = createAsyncThunk('thumbnails/get', async (arg, thunkAPI) => {
    try {
        const response = await getThumbnails(arg)
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const getFileIndicators = createAsyncThunk('file-indicators/get', async (arg, thunkAPI) => {
    try {
        const response = await getIndicators(arg)
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const recacheIndicators = createAsyncThunk(
    'file-indicators/recache',
    async (arg, thunkAPI) => {
        try {
            const { thumbnails } = thunkAPI.getState()
            const { indicatorsCache } = thumbnails
            await thunkAPI.dispatch(invalidateIndicators())
            const response = await getIndicators({ ids: indicatorsCache })
            return { ...response.data, meta: indicatorsCache }
        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

const initialState = {
    ...thumbnailAdapter.getInitialState(),
    collectionFileIds: [],
    tagFileIds: [],
    shareFileIds: [],
    indicatorsCache: [],
    isLoading: false,
    isError: false,
}

const thumbnailSlice = createSlice({
    name: 'thumbnails',
    initialState,
    reducers: {
        invalidateIndicators: (state, { payload }) => {
            state.indicatorsCache = payload
                ? state.indicatorsCache.filter(i => !payload.includes(i))
                : []
            state.collectionFileIds = payload
                ? state.collectionFileIds.filter(i => !payload.includes(i))
                : []
            state.tagFileIds = payload ? state.tagFileIds.filter(i => !payload.includes(i)) : []
            state.shareFileIds = payload ? state.shareFileIds.filter(i => !payload.includes(i)) : []
        },
    },
    extraReducers: builder => {
        builder.addCase(getFileThumbnails.pending, state => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getFileThumbnails.fulfilled, (state, { payload }) => {
            thumbnailAdapter.upsertMany(state, payload.data)
            state.isLoading = false
        })
        builder.addCase(getFileThumbnails.rejected, state => {
            state.isLoading = false
            state.isError = true
        })
        builder.addCase(getFileIndicators.fulfilled, (state, { payload, meta }) => {
            state.indicatorsCache = [
                ...new Set([...state.indicatorsCache, ...meta.arg.ids.split(',')]),
            ]
            state.collectionFileIds = [
                ...new Set([...state.collectionFileIds, ...payload.data.collectionFileIds]),
            ]
            state.tagFileIds = [...new Set([...state.tagFileIds, ...payload.data.tagFileIds])]
            state.shareFileIds = [...new Set([...state.shareFileIds, ...payload.data.shareFileIds])]
        })
        builder.addCase(recacheIndicators.fulfilled, (state, { payload }) => {
            const { meta, data } = payload
            state.indicatorsCache = meta
            state.collectionFileIds = data.collectionFileIds
            state.tagFileIds = data.tagFileIds
            state.shareFileIds = data.shareFileIds
        })
    },
})

export const { invalidateIndicators } = thumbnailSlice.actions

export default thumbnailSlice.reducer
